/**
 * 同步哈希密码
 * @param {string} password - 原始密码
 * @returns {Promise<string>} - 哈希后的密码（base64格式）
 */
export function hashPasswordSync(password) {
  return new Promise((resolve, reject) => {
    try {
      // Convert the password string to a Uint8Array
      const passwordBuffer = new TextEncoder().encode(password)
      // Calculate the SHA-256 hash
      crypto.subtle
        .digest('SHA-256', passwordBuffer)
        .then((hashBuffer) => {
          // Convert the hash to a base64-encoded string
          const hashArray = Array.from(new Uint8Array(hashBuffer))
          const hashBase64 = btoa(String.fromCharCode(...hashArray))
          resolve(hashBase64)
        })
        .catch((error) => {
          reject(error)
        })
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * SHA-256 哈希（十六进制小写输出，用于 TikTok Pixel identify 等场景）
 * @param {string} text - 原始文本
 * @returns {Promise<string>} - 哈希后的十六进制字符串
 */
export function sha256Hex(text) {
  return new Promise((resolve, reject) => {
    try {
      const buffer = new TextEncoder().encode(text)
      crypto.subtle
        .digest('SHA-256', buffer)
        .then((hashBuffer) => {
          const hex = Array.from(new Uint8Array(hashBuffer))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('')
          resolve(hex)
        })
        .catch((error) => {
          reject(error)
        })
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * 生成随机字符串
 * @param {number} length - 字符串长度
 * @returns {string} - 随机字符串
 */
export function generateRandomString(length = 16) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

/**
 * 格式化日期
 * @param {Date|string} date - 日期对象或字符串
 * @param {string} format - 格式化模板，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} - 格式化后的日期字符串
 */
export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}